import styled from "styled-components";

export const StyledBattle = styled.div`
    height: 100vh;
    iframe {
        width: 100%;
        height: 100%;
        border: none;
    }
`;
